// if any colors are added here, they should also be added to _variables.scss
export const theme = {
    // app colors
    accent: "#4585ff",
    error: '#b71c1c',
    label: "#757575",
    white: "#fff", 
    
    primary: "#0c558c",
    primaryLighten2: "#f0f4f7",
    
    secondary: "#c21c20",
    secondaryLighten2: '#f9e7e8',
    
    

    // narratives
    aapi: "#3e858a",
    aapiLighten2: "#F1F9FA",

    all: "#0c558c",
    allLighten2: "#f0f4f7",

    black: "#006400",
    blackLighten2: "#ecf2eb",
    
    flipped: "#4facfe",
    flippedLighten2: "#EFF7FE",
    
    gotv: "#f0831c",
    gotvLighten2: "#FAF3EC",
    
    latino: "#BE9631",
    latinoLighten2: "#F8F4E6",
    
    lgbtq: "#F81603",
    lgbtqLighten2: "#FAEBE8",

    nativeAmerican: "#130f40",
    nativeAmericanLighten2: "#d7d7e0",

    native_american: "#130f40",
    native_americanLighten2: "#d7d7e0",

    new: "#02ba2d",
    newLighten2: "#EFF8ED",
    
    poc: "#7739da",
    pocLighten2: "#EFECFA",
    
    technology: "#424242",
    technologyLighten2: "#E5E5E5",
    
    women: "#F258BD",
    womenLighten2: "#FAEFF7",
}